import { Link, useLocation } from "react-router-dom";
import { Icon } from "semantic-ui-react";

import { ProgressBar } from "components";
import "components/NavBar/NavBar.scss";
import { getRouteProperties } from "components/NavBar/routes";
import { useAuth, useNavAction } from "hooks";

type NavBarProps = {
  openSidebar: () => void;
};

export const NavBar = ({ openSidebar }: NavBarProps) => {
  const location = useLocation();
  const action = useNavAction();
  const route = getRouteProperties(location);
  const { logout } = useAuth();

  return (
    <div className={`nav-bar-wrapper`}>
      <div className="nav-bar-content">
        <ProgressBar />
        <div className="nav-bar-start">
          <div className="pointer" onClick={openSidebar}>
            <Icon name="bars" color="black" />
          </div>
          {route.title}
        </div>

        <div id="navbar-portal-container" />

        <div className="nav-bar-start">
          {action && (
            <Link className="button" to="#" onClick={action.onClick}>
              <Icon className="arrows rotate regular i-grey" />
            </Link>
          )}
          <button onClick={() => logout()} className="logout-button">
            <span>Logout</span>
          </button>
        </div>
      </div>
    </div>
  );
};
